var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 120,
    viewBox: "0 0 135 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.992 60.8145C135.805 27.8009 93.2709 6.51584 67.7772 0H127C131.418 0 135 3.58172 135 8V112C135 116.418 131.418 120 127 120H-24C3.90886 114.027 68.1797 93.8281 101.992 60.8145Z",
    fill: "black",
    fillOpacity: 0.02
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceBg);
export default __webpack_public_path__ + "static/media/service_bg.0a53b38a3efed4a536aa6f72f824f076.svg";
export { ForwardRef as ReactComponent };